module.exports = __webpack_public_path__ + "img/65bce03.svg";